import Slider from "react-slick";
import React, {
  Fragment,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router";
import { TYPE, URL } from "../../../constant";
import { useLoading, useUserInfo } from "../../../hooks";
import useAmplitude from "../../../hooks/useAmplitude";
import useHackleInfo from "../../../hooks/useHackle";
import { ResponsiveContainer } from "recharts";
import { appsflyer, appsflyerEventName } from "../../../utils/appsflyer";

const DEFAULT_IMG_PATH = "./static/images/common/introduction";
const item = {
  ko: {
    A: [
      {
        intro_tit: "/ko/main_tit.svg",
        intro_tit_alt:
          "매쓰피드 전 세계 175개국의 학생들이 학습하는 매쓰피드! 매쓰피드를 통해 30,000개 이상의 문제와 개인 맞춤형 연산 학습을 체험해 보세요!",
      },
      {
        tit: "선생님과 학부모가 <br/>인정하는 매쓰피드!",
        txt: "전 세계의 선생님과 학부모에게 인정 받은 매쓰피드는, <br/>항상 사용자들의 학습 결과를 돌아보고 <br/>컨텐츠에 반영 합니다.",
        intro_img: "/ko/intro_img_01.png",
      },
      {
        tit: "실리콘밸리 기반 AI 기술로 <br/>맞춤형 학습을 체험해 보세요.",
        txt: "선생님과 학부모를 위해 AI 진단 기술이 알아서 <br/>학생의 약점을 파악하고, 학생에게 꼭 맞는 <br/>학습 진도를 추천해 줍니다.",
        intro_img: "/ko/intro_img_02.png",
      },
      {
        tit: "사진 한 컷으로 제한 없는 <br/>연산 학습을 시작해 보세요.",
        txt: "매쓰피드는 사진 속 수학 문제를 자동으로 인식해, <br/>학습하면 도움이 될 유사한 문제를 추천해줍니다. <br/>전문가에게 검증된 연산 문제를 제한 없이 학습해 보세요. ",
        intro_img: "/ko/intro_img_03.png",
        submitBtn: true,
      },
    ],
    B: [
      {
        tit: "쉽고 빠르게 수학 상위권이 <br />되는 방법!",
        txt: "전세계 175개국 학생들이<br />매쓰피드와 함께 합니다!",
        sub_text: "결과로 입증된 학습 효과를 <br />경험하세요.",
        intro_img: "/ko/intro_img_01_typeB.png",
      },
      {
        tit: "주제별로 알기 쉽게 제공되는 <br />무제한 문제 풀이!",
        txt: "매쓰피드의 문제 은행과 함께하면<br />성적은 쑥쑥! 자신감은 팍팍!",
        sub_text: null,
        intro_img: "/ko/intro_img_02_typeB.png",
      },
      {
        tit: "개인화 AI 선생님이<br />최적화된 학습을 제공합니다.",
        txt: "실리콘 밸리의 차세대 AI 교육 <br />플랫폼으로 취약점은 보완하고 강점은<br />더 확실하게! ",
        sub_text: null,
        intro_img: "/ko/intro_img_03_typeB.png",
      },
      {
        tit: "어려운 문제는<br />사진만 찍으면 해결!",
        txt: "모르는 문제는 <br />개념영상으로 확실하게!<br />같은 유형의 문제로 복습까지 완벽정복!",
        sub_text: null,
        intro_img: "/ko/intro_img_04_typeB.png",
      },
      {
        tit: "AI 진단 분석을 통해<br />취약점 분석부터 추천 학습까지!",
        txt: "오답이 발생한 원인을 <br />실시간을 분석하여 <br />난이도를 조정합니다",
        sub_text: null,
        intro_img: "/ko/intro_img_05_typeB.png",
        submitBtn: true,
      },
    ],
    C: [
      {
        tit: "쉽고 빠르게 수학 상위권이 <br />되는 방법!",
        txt: "전세계 175개국 학생들이<br />매쓰피드와 함께 합니다!",
        sub_text: "결과로 입증된 학습 효과를 <br />경험하세요.",
        intro_img: "/ko/intro_img_01_typeC.png",
      },
      {
        tit: "주제별로 알기 쉽게 제공되는 <br />무제한 문제 풀이!",
        txt: "총 3만여 개의 문제! <br />최고의 교육 전문가들의 큐레이션으로<br />탄생한 <span class='point_txt'>'주제 학습'</span>을 경험하세요",
        sub_text: null,
        intro_img: "/ko/intro_img_02_typeC.png",
      },
      {
        tit: "개인화 AI 선생님이<br />최적화된 학습을 제공합니다.",
        txt: "실리콘 밸리의 차세대 AI 교육 <br />플랫폼으로 취약점은 보완하고 강점은<br />더 확실하게! ",
        sub_text: null,
        intro_img: "/ko/intro_img_03_typeC.png",
      },
      {
        tit: "어려운 문제는<br />사진만 찍으면 해결!",
        txt: "모르는 문제는 <br />개념영상으로 확실하게!<br />같은 유형의 문제로 복습까지 완벽정복!",
        sub_text: null,
        intro_img: "/ko/intro_img_04_typeC.png",
      },
      {
        tit: "AI 진단 분석을 통해<br />취약점 분석부터 추천 학습까지!",
        txt: "오답이 발생한 원인을 <br />실시간을 분석하여 <br />난이도를 조정합니다",
        sub_text: null,
        intro_img: "/ko/intro_img_05_typeC.png",
        submitBtn: true,
      },
    ],
  },
  en: {
    A: [
      {
        intro_tit: "/en/option_a.svg",
        intro_tit_alt:
          "AI arithmetic Mathpid. Students from 175 countries are studying with Mathpid!",
      },
      {
        tit: "Parents and Teachers <br/>all Agree on One thing!",
        txt: "Approved by global parents and teachers! <br/>Mathpid keeps your math lessons <br/>engaged with real-user results.",
        intro_img: "/en/intro_img_01.png",
      },
      {
        tit: "Silicon-Valley AI tech sets <br/>personalized learning path",
        txt: "No help needed from the adults! <br/>AI diagnosis discovers weakness and <br/>Recommends personalized math lessons.",
        intro_img: "/en/intro_img_02.png",
      },
      {
        tit: "Snap a pic and meet our <br/>Unlimited Math Problems",
        txt: "Mathpid scans your problem and recommends <br/>similar problems to work your math exercise <br/>from Global Curriculum aligned problem bank.",
        intro_img: "/en/intro_img_03.png",
        submitBtn: true,
      },
    ],
    B: [
      {
        tit: "Be the Math Ace,<br />with no pain!",
        txt: "Student from 175 countries<br />are studying with Mathpid!",
        sub_text: "Parents &amp; Experts <br />All Agree on one thing!",
        intro_img: "/en/intro_img_01_typeB.png",
      },
      {
        tit: "Prepare Exam with<br />Curated Question Bank!",
        txt: "Mathpid provides unlimited problems <br />for each topic. Prepare Exam Perfectly <br />and Improve the math grades",
        sub_text: null,
        intro_img: "/en/intro_img_02_typeB.png",
      },
      {
        tit: " Start Personalized Practice<br />&amp;Guides with App Tutor",
        txt: "We provides Learning experience<br />only for your kids with Mathpid, <br />Highly praised by Silicon Valley.",
        sub_text: null,
        intro_img: "/en/intro_img_03_typeB.png",
      },
      {
        tit: "Snap a pic and Master<br />difficult practices",
        txt: "When kids have difficulty with<br />worksheet, Just take a photo, We<br />provide similar practices & concept videos",
        sub_text: null,
        intro_img: "/en/intro_img_04_typeB.png",
      },
      {
        tit: "Track Progress<br />&amp; Result whenever,<br />with Detailed Reports",
        txt: "Check kids Math level and Get detailed<br />feedback report without waiting! At<br />anytime, anywhere!",
        sub_text: null,
        intro_img: "/en/intro_img_05_typeB.png",
        submitBtn: true,
      },
    ],
    C: [
      {
        tit: "Be the Math Ace,<br />with no pain!",
        txt: "Student from 175 countries<br />are studying with Mathpid!",
        sub_text: "Parents &amp; Experts <br />All Agree on one thing!",
        intro_img: "/en/intro_img_01_typeC.png",
      },
      {
        tit: "Prepare Exam with<br />Curated Question Bank!",
        txt: "Get Unlimited practices as a <span class='point_txt'>Daily Topic</span><br />With 30,000+ Curated Questions<br />by educational experts",
        sub_text: null,
        intro_img: "/en/intro_img_02_typeC.png",
      },
      {
        tit: "Start Personalized Practice<br />&amp;Guides with App Tutor",
        txt: "Start Learning experience only for your kids <br />with <span class='point_txt'>Daily Course</span>,<br />Highly praised by Silicon Valley.",
        sub_text: null,
        intro_img: "/en/intro_img_03_typeC.png",
      },
      {
        tit: "Snap a pic and Master<br />difficult practices",
        txt: "When kids have difficulty with <br />worksheet, Use <span class='point_txt'>Math Camera</span>! <br />We provide similar practices & concept videos",
        sub_text: null,
        intro_img: "/en/intro_img_04_typeC.png",
      },
      {
        tit: "Track Progress<br />&amp; Result whenever,<br />with Detailed Reports",
        txt: "Check kids Math level and <br />Get detailed feedback as a <span class='point_txt'>Progress report</span>,  <br />At anytime, anywhere!",
        sub_text: null,
        intro_img: "/en/intro_img_05_typeC.png",
        submitBtn: true,
      },
    ],
  },
};

function InformationGB() {
  const history = useHistory();
  const { i18n } = useTranslation();
  const { info } = useUserInfo();
  const { setAmplitudeLog } = useAmplitude();
  const [, setLocale] = useState("");
  const { info: hackleInfo, setHackleInfo, clearHackleInfo } = useHackleInfo();
  const getHackle = hackleInfo?.INTRODUCTION_PAYMENT;
  const { setLoading, clearLoading } = useLoading();

  useEffect(() => {
    const l = localStorage.getItem("locale");
    if (l) setLocale(l.toLowerCase());

    const isIntroductionView = localStorage.getItem("gb_introduction");

    /**
     * isShowHackle 조건
     * 1. 결제국가 사용자
     * 2. 한글 및 모바일, 태블릿 버전 적용
     * 3. dev 에서 모바일 영문만 적용
     */
    let isShowHackle = info.isPaymentCountry;

    // if (
    //   process.env.REACT_APP_ENV === "development" ||
    //   process.env.REACT_APP_ENV === "local"
    // ) {
    //   isShowHackle = info.isPaymentCountry && i18n?.language === "en";
    // }

    setHackleInfo({
      viewPath: "INTRODUCTION_PAYMENT",
      isShowHackle, // isShowHackle 조건
    });

    setAmplitudeLog({
      eventCategory: "on-boarding",
      eventName: "on-boarding화면 조회",
      isHackleSend: !isIntroductionView || isIntroductionView === "N",
    });

    // return () => {
    //   if (!isIntroductionView || isIntroductionView === "N") {
    //     localStorage.setItem("gb_introduction", "Y");

    //     // 결제국가, 미구독 인경우
    //     if (info.isPaymentCountry && !info.subScriptionPurchsYn) {
    //       history.push(URL.PAYMENT.BEFORE); // 결제유도 팝업 호출
    //     } else {
    //       history.push(URL.SELECT_LEARNING, { prevPoint: "init_appLogin" }); // 메인
    //     }
    //   }
    // };
  }, [info]);

  useEffect(() => {}, [getHackle]);

  const handlePage = useCallback(() => {
    document.getElementById("learningBtn").disabled = true;
    setAmplitudeLog({
      eventCategory: "on-boarding",
      eventName: "학습시작하기 클릭",
    });

    // history.push(URL.SELECT_LEARNING, { prevPoint: "init_appLogin" });

    const isIntroductionView = localStorage.getItem("gb_introduction");
    if (!isIntroductionView || isIntroductionView === "N") {
      localStorage.setItem("gb_introduction", "Y");

      // 결제국가, 미구독 인경우
      if (info.isPaymentCountry && !info.subScriptionPurchsYn) {
        
        if(info?.countryCd === TYPE.COUNTRY_CODE.KOREA) {
          // KR
          history.push(URL.PAYMENT.BEFORE); // 결제유도 팝업 호출
        } else {
          // IN, PH, US, GB
          history.push({
            pathname : URL.PAYMENT.SUBSCRIBE_NEW,
            state : {
              isOnBoarding : true
            }
          }); // 결제 팝업 호출(온보딩용)
        }
      } else {
        history.push(URL.SELECT_LEARNING, { prevPoint: "init_appLogin" }); // 메인
      }
    } else {
      history.push(URL.SELECT_LEARNING);
    }
  }, [info]);

  const clear = () => {
    clearHackleInfo({ viewPath: "INTRODUCTION_PAYMENT" });
  };


  useEffect(() => {
    appsflyer({
      eventName: appsflyerEventName.on_boarding_viewed,
      eventParams: null
    });
    return clear();
  }, []);

  const setting = {
    dots: true,
    arrows: false,
  };

  return (
    <div className="skyblue">
      <div className="intro_global_wrap">
        <div className="header_top gb intro_header">
          <div className="inner">
            <div className="btns_wrap">
              <div className="center_wrap cls">
                <div className="tit_area">
                  <button className="btn_logo" type="button">
                    매쓰피드 로고
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="inner">
            {!getHackle?.isShowHackle && (
              <div className="slide_cont otTypeA">
                <Slider
                  className="slick_slider js_slick slick-dotted"
                  {...setting}
                >
                  {/* HACKLE OFF*/}
                  {item[i18n.language]["A"].map((item, index) => {
                    const { intro_tit, intro_tit_alt, intro_img } = item;

                    return (
                      <div key={index} className="slide_wrap">
                        <div
                          className={`cont_box ${
                            index == 0 ? i18n.language : 'cont0' + index
                          }`}
                        >
                          {
                            // index 0
                            index === 0 && (
                              <div className="tit_area">
                                <div className={`${i18n.language}`}>
                                  <img
                                    className="intro_tit"
                                    src={`${DEFAULT_IMG_PATH}${intro_tit}`}
                                    alt={intro_tit_alt}
                                  />
                                </div>
                              </div>
                            )
                          }
                          {
                            // index 1 이상
                            index > 0 && (
                              <>
                                <div className="sld_box">
                                  {/* <span className="blind">{index}</span> */}
                                  <p
                                    className="tit"
                                    dangerouslySetInnerHTML={{
                                      __html: item.tit,
                                    }}
                                  />
                                  <p
                                    className="txt"
                                    dangerouslySetInnerHTML={{
                                      __html: item.txt,
                                    }}
                                  />
                                </div>
                                <div className="img">
                                <img
                                  src={`${DEFAULT_IMG_PATH}${intro_img}`}
                                  alt=""
                                />
                                </div>
                              </>
                            )
                          }
                        </div>
                        {item.submitBtn && (
                          <div className={`floating_area ${i18n.language}`}>
                            <button
                              id="learningBtn"
                              className={`btn btn-blue ${i18n.language}`}
                              onClick={handlePage}
                            >
                              {i18n.language === "en"
                                ? "start"
                                : "학습 시작하기"}
                            </button>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </Slider>
              </div>
            )}
            {getHackle?.isShowHackle && (
              <div className={`slide_cont otType${getHackle?.variation}`}>
                <Slider
                  className="slick_slider js_slick slick-dotted"
                  {...setting}
                >
                  {/* HACKLE ON*/}
                  {item[i18n.language][getHackle?.variation].map((item, index) => {
                    const { intro_tit, intro_tit_alt, intro_img } = item;

                    return (
                      <div key={index} className="slide_wrap">
                        <div
                          className={`cont_box ${
                            (getHackle?.variation === "A" && index == 0 ) ? i18n.language :
                            (getHackle?.variation === "A" && index > 0 ) ? 'cont0' + index : 'cont0' + (index + 1)
                          }`}
                        >
                          {
                            // index 0
                            (getHackle?.variation === "A" && index === 0) && (
                              <div className="tit_area">
                                <div className={`${i18n.language}`}>
                                  <img
                                    className="intro_tit"
                                    src={`${DEFAULT_IMG_PATH}${intro_tit}`}
                                    alt={intro_tit_alt}
                                  />
                                </div>
                              </div>
                            )
                          }
                          {
                            // index 1 이상
                            (getHackle?.variation === "A" && index > 0) && (
                              <>
                                <div className="sld_box">
                                  {/* <span className="blind">{index}</span> */}
                                  <p
                                    className="tit"
                                    dangerouslySetInnerHTML={{
                                      __html: item.tit,
                                    }}
                                  />
                                  <p
                                    className="txt"
                                    dangerouslySetInnerHTML={{
                                      __html: item.txt,
                                    }}
                                  />
                                  {item.sub_text && (
                                    <p
                                      className="sub_txt bg_score"
                                      dangerouslySetInnerHTML={{
                                        __html: item.sub_text,
                                      }}
                                    />
                                  )}
                                </div>
                                <div className="img">
                                <img
                                  src={`${DEFAULT_IMG_PATH}${intro_img}`}
                                  alt=""
                                />
                                </div>
                              </>
                            )
                          }
                          {
                            getHackle?.variation !== "A" && (
                              <>
                                <div className="sld_box">
                                  {/* <span className="blind">{index}</span> */}
                                  <p
                                    className="tit"
                                    dangerouslySetInnerHTML={{
                                      __html: item.tit,
                                    }}
                                  />
                                  <p
                                    className="txt"
                                    dangerouslySetInnerHTML={{
                                      __html: item.txt,
                                    }}
                                  />
                                  {item.sub_text && (
                                    <p
                                      className="sub_txt bg_score"
                                      dangerouslySetInnerHTML={{
                                        __html: item.sub_text,
                                      }}
                                    />
                                  )}
                                </div>
                                <div className="img">
                                <img
                                  src={`${DEFAULT_IMG_PATH}${intro_img}`}
                                  alt=""
                                />
                                </div>
                              </>
                            )
                          }
                        </div>
                        {item.submitBtn && (
                          <div className={`floating_area ${i18n.language}`}>
                            <button
                              id="learningBtn"
                              className={`btn btn-blue ${i18n.language}`}
                              onClick={handlePage}
                            >
                              {i18n.language === "en"
                                ? "start"
                                : "학습 시작하기"}
                            </button>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </Slider>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default InformationGB;
